var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTargetColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2559 7.25586H14.0466C13.7118 4.48367 11.5163 2.2883 8.74414 1.9534V0.744138C8.74414 0.334826 8.40931 0 8 0C7.59069 0 7.25586 0.334826 7.25586 0.744138V1.9534C4.48367 2.28823 2.2883 4.4837 1.9534 7.25586H0.744138C0.334826 7.25586 0 7.59069 0 8C0 8.40931 0.334826 8.74414 0.744138 8.74414H1.9534C2.28823 11.5163 4.4837 13.7117 7.25586 14.0466V15.2559C7.25586 15.6652 7.59069 16 8 16C8.40931 16 8.74414 15.6652 8.74414 15.2559V14.0466C11.5163 13.7118 13.7117 11.5163 14.0466 8.74414H15.2559C15.6652 8.74414 16 8.40931 16 8C16.0001 7.59069 15.6652 7.25586 15.2559 7.25586ZM8.74407 12.5583V11.4607C8.74407 11.0513 8.40925 10.7165 7.99993 10.7165C7.59062 10.7165 7.2558 11.0513 7.2558 11.4607V12.5583C5.30223 12.242 3.75803 10.6978 3.44175 8.74427H4.53942C4.94873 8.74427 5.28355 8.40945 5.28355 8.00013C5.28355 7.59082 4.94873 7.256 4.53942 7.256H3.44175C3.75802 5.30242 5.30226 3.75823 7.2558 3.44195V4.53962C7.2558 4.94893 7.59062 5.28375 7.99993 5.28375C8.40925 5.28375 8.74407 4.94893 8.74407 4.53962V3.44195C10.6976 3.75822 12.2418 5.30246 12.5581 7.256H11.4605C11.0511 7.256 10.7163 7.59082 10.7163 8.00013C10.7163 8.40945 11.0511 8.74427 11.4605 8.74427H12.5581C12.2419 10.6978 10.6976 12.242 8.74407 12.5583Z",
    fill: "url(#paint0_linear_6098_22197)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6098_22197",
    x1: 14,
    y1: 14.5,
    x2: 2,
    y2: 3.72529e-8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D56CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#207DEC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetColored);
export default __webpack_public_path__ + "static/media/target-colored.9d03abdb7b2205b027b68574b2be0d84.svg";
export { ForwardRef as ReactComponent };